import { render, staticRenderFns } from "./ATextarea.vue?vue&type=template&id=3d2a24ee"
import script from "./ATextarea.vue?vue&type=script&lang=js"
export * from "./ATextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports